require('./personal-block.less');

let size = require('../../modules/size');

jQuery(function() {
    $('.js-show-auth-links-block').click(function() {
        if (window.innerWidth >= size.desktop) {
            var $this = $(this);
            var $links = $this.find('.personal-block__links');

            $links.show();
            setTimeout(function() {
                $this.addClass('personal-block--hover');
            }, 100);
        }
    });

    $(document).click(function(e) {
        var $personalBlock = $('.js-show-auth-links-block');
        var $links = $personalBlock.find('.personal-block__links');

        var $target = $(e.target);

        if ($target.is($personalBlock) || $target.closest('.js-show-auth-links-block').length > 0) return;

        $personalBlock.removeClass('personal-block--hover');
        setTimeout(function() {
            $links.hide();
        }, 350);
    });
});



// WEBPACK FOOTER //
// ./blocks/personal-block/personal-block.js